import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProposalBillingItem, ProposalReceipt } from "app/entities";

@Component({
    selector: "app-proposal-receipt-dialog",
    templateUrl: "./proposal-receipt-dialog.component.html",
    styleUrls: ["./proposal-receipt-dialog.component.scss"]
})
export class ProposalReceiptDialogComponent implements OnInit {
    form?: FormGroup;

    readonly paymentMethods = [
        { value: 'cash', label: 'Dinheiro' },
        { value: 'credit_card', label: 'Cartão de crédito' },
        { value: 'debit_card', label: 'Cartão de débito' },
        { value: 'pix', label: 'Pix' },
        { value: 'bank_transfer', label: 'Transferência bancária' },
        { value: 'boleto', label: 'Boleto' },
        { value: 'other', label: 'Outro' },
    ];

    constructor(
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: {
            mode: 'create' | 'edit';
            item?: ProposalBillingItem;
            receipt?: ProposalReceipt;
            proposalTitle?: string;
        },
        private dialogRef: MatDialogRef<ProposalReceiptDialogComponent>
    ) { }

    ngOnInit(): void {
        const receipt = this.data.receipt;
        const item = this.data.item || receipt?.billingItem;

        this.form = this.fb.group({
            issueDate: [receipt?.issueDate || new Date(), Validators.required],
            amount: [receipt?.amount || item?.amount || 0, [Validators.required, Validators.min(0.01)]],
            paymentReference: [{ value: receipt?.paymentReference || item?.description || '', disabled: true }, Validators.required],
            paymentMethod: [receipt?.paymentMethod || null],
            description: [receipt?.description || this.defaultDescription(item), Validators.required],
            showSignature: [receipt?.showSignature ?? true],
        });
    }

    get isEdit(): boolean {
        return this.data.mode === 'edit';
    }

    get hasAmountDivergence(): boolean {
        const itemAmount = this.data.item?.amount || this.data.receipt?.billingItem?.amount;
        const amount = Number(this.form?.get('amount')?.value || 0);

        return !!itemAmount && Math.abs(Number(itemAmount) - amount) > 0.01;
    }

    confirm(): void {
        if (!this.form?.valid) {
            return;
        }

        this.dialogRef.close(this.form.getRawValue());
    }

    private defaultDescription(item?: ProposalBillingItem): string {
        const reference = item?.description || 'pagamento do orçamento';

        return `Recebemos o valor referente a ${reference}. Este recibo comprova o recebimento do valor informado.`;
    }
}
